// Abrir el plan de la marca activa desde cualquier lado (ADR-2026-10-28-elegir-plan-de-marca).
// Lo escucha `HostDelPlanDeMarca`, montado una vez en la raíz de la app. Los botones de
// "sin créditos" / "mejorar plan" pasan por acá con lo que hacían antes como `sino`.
//
// Con el saldo ya leído decide en el acto: sin bandera corre `sino` sincrónico (igual que
// antes); con bandera abre el plan de la marca, también sin marca resuelta (el modal muestra
// el error: nunca se cae al catálogo de la empresa). Sin saldo leído todavía, lo lee primero
// y decide con lo que devuelve esa lectura (ADR-2026-10-28-elegir-plan-de-marca-2); si falla
// o tarda más de `TOPE_LECTURA_MS`, `sino`: un click nunca queda sin hacer nada. Tras un
// cambio de marca el saldo guardado es de la marca anterior y no cuenta como leído: abrir el
// plan ahí cambiaría el de la marca equivocada (ADR-2026-10-28-review-greptile-plan-por-marca).

import { asegurarSaldoLeido, ultimoSaldoVigente, type Saldo } from '../../lib/saldo';
import { pedidoDePlanDeMarca, type PedidoDePlanDeMarca } from './planDeMarca';

export const EVENTO_ABRIR_PLAN_DE_MARCA = 'atlas:abrir-plan-de-marca';
export const TOPE_LECTURA_MS = 3000;

function decidir(saldo: Saldo | null, sino: () => void): void {
  const pedido = pedidoDePlanDeMarca(saldo);
  if (!pedido) return sino();
  window.dispatchEvent(new CustomEvent<PedidoDePlanDeMarca>(EVENTO_ABRIR_PLAN_DE_MARCA, { detail: pedido }));
}

export function abrirPlanDeMarcaOSino(sino: () => void): void {
  const saldo = ultimoSaldoVigente();
  if (saldo) return decidir(saldo, sino);
  void asegurarSaldoLeido({ topeMs: TOPE_LECTURA_MS }).then((s) => decidir(s, sino));
}
